import { EarningsInsight } from '@api';
import { parseEarningsInsights } from '@terminal/react-query-hooks/insights/useEarningsInsightsFilter.utils';

import {
  CalendarEvents,
  isEarningsEvent,
  isEconomicEvent,
} from '../../calendar-event-drawer/utils';

export const getReportedValueTextColor = (
  estimated?: number,
  actual?: number
) => {
  const hasValidValues = !!actual && !!estimated;

  switch (true) {
    case !estimated || !actual:
      return 'var(--text-default)';
    case hasValidValues && actual > estimated:
      return 'var(--viz-bullish)';
    case hasValidValues && actual < estimated:
      return 'var(--viz-bearish)';
    default:
      return 'var(--text-default)';
  }
};

type CalendarEventType = 'earnings' | 'economic' | 'company';

export const getCalendarEventType = (e: CalendarEvents): CalendarEventType =>
  isEarningsEvent(e) ? 'earnings' : isEconomicEvent(e) ? 'economic' : 'company';

export const getEarningsInsight = (
  earningsInsightsData: EarningsInsight[],
  earningsId?: string
) => {
  const filteredEarningsInsightsData = earningsInsightsData.filter(
    e => e.earnings_id === earningsId
  );
  return parseEarningsInsights(filteredEarningsInsightsData);
};
